import { useTableProvider } from "../../providers";

import { MainContentComponent, TableComponent } from "components";
import {
  HeaderLeft,
  TableItems,
  TablePaginationComponent,
  AddNewBrandButtonComponent,
} from "..";

export function MainComponent() {
  const { isLoading } = useTableProvider();

  return (
    <MainContentComponent
      headerLeft={<HeaderLeft />}
      headerRight={<AddNewBrandButtonComponent />}
    >
      <TableComponent>
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Created At</th>
            <th></th>
          </tr>
        </thead>
        <TableComponent.Body colCount={4} isLoading={isLoading}>
          <TableItems />
        </TableComponent.Body>
        <TableComponent.Pagination>
          <TablePaginationComponent />
        </TableComponent.Pagination>
      </TableComponent>
    </MainContentComponent>
  );
}
